import React, { ReactNode, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import koopLogo from '../../../assets/koop-draft-logo.png';
import iconAdmin from '../../../assets/admin.png';
import iconUsername from '../../../assets/profile.png';
import iconLoan from '../../../assets/loans.png';
import iconDash from '../../../assets/dash.png';
import iconLogout from '../../../assets/logout.png';
import iconImport from '../../../assets/import-data.png';
import iconMenu from '../../../assets/menu.png';

import helperIndex from '../../../helpers/index';

import MessageModal from '../../Modal/MessageModal';

import warningIcon from '../../../assets/warning-icon.png';
import helper from '../../../helpers/index';

interface AdminLayoutProps {
	children: ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {

	const dispatch = useDispatch();
	const location = useLocation();

	const [logUser, setLogUser] = useState('');
	const [modalMessage, setModalMessage] = useState('');
	const [modalMessageOpen, setModalMessageOpen] = useState(false);
	const [isSidebarOpen, setIsSidebarOpen] = useState(true);
	const [activePath, setActivePath] = useState<string>(location.pathname);

	var username = helperIndex.getCookieValue('username');

	function checkTokenExpiration() {
		var intervalMinutes = Number(process.env.REACT_APP_CHECK_TOKEN_INTERVAL) * 60000;

		setInterval(function () {
			var refreshToken: string = helper.getCookieValue('refreshToken');
			if (!refreshToken) {
				setModalMessage("Session has expired. Please login again");
				setModalMessageOpen(true);
			}
		}, intervalMinutes);
	}

	function onClose() {
		setModalMessageOpen(false);
		window.location.href = '/Admin/Login';
	}

	useEffect(() => {
		(async () => {
			var isNotExpired = await dispatch({ type: 'middleware' });
			if (typeof isNotExpired === 'boolean') {
				if (!isNotExpired) {
					setModalMessage("Session has expired. Please login again");
					setModalMessageOpen(true);
				}
			}
			checkTokenExpiration();
			setLogUser(username);

			const savedActivePath = localStorage.getItem('activePath');
			if (savedActivePath) {
				setActivePath(savedActivePath);
			}
		})();
	}, []);

	const handleNavClick = (path: string) => {
		setActivePath(path);
		localStorage.setItem('activePath', path);
		setIsSidebarOpen(false); // Close sidebar on mobile after clicking a link
	};


	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth <= 992) {
				setIsSidebarOpen(false);
			} else {
				setIsSidebarOpen(true);
			}
		};





		window.addEventListener('resize', handleResize);

		handleResize();

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);


	const handleClickOutside = (event: MouseEvent) => {
		const sidebar = document.querySelector('.sidebar');
		if (
			isSidebarOpen &&
			window.innerWidth <= 992 &&
			sidebar &&
			!sidebar.contains(event.target as Node)
		) {
			setIsSidebarOpen(false);
		}
	};
	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};
	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isSidebarOpen]);

	return (
		<div className='loader-container' style={{ display: "flex", height: "100vh" }}>

			<MessageModal message={modalMessage} icon={warningIcon} isOpen={modalMessageOpen} onClose={onClose} />

			<div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`} style={{
				transform: isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
				// transition: 'transform 0.3s ease-in-out',
				position: isSidebarOpen ? undefined : 'absolute'
			}}>
				<div style={{ display: "flex", margin: "20px", gap: "8px" }}>
					<div className="icon-koop">
						<img className="responsive-image" src={koopLogo} alt="Koop Logo" />
					</div>
					<div className="vertical-middle">
						<div style={{ paddingLeft: "5px" }} className="font-green left-align font-bold width-100 font-size-17px ">
							KOOP BATANGAN MPC
						</div>
						<div style={{ paddingLeft: "5px" }} className="font-green left-align width-100 ">
							LOAN MANAGEMENT
						</div>
					</div>

				</div>

				<div className='navigator-container'>
					<ul>
						<li className={activePath === '/Admin/Dashboard' ? 'active' : ''}>
							<Link to="/Admin/Dashboard" onClick={() => handleNavClick('/Admin/Dashboard')}>
								<img src={iconDash} className="sidebar-icon" alt="Import" /> Dashboard
							</Link>
						</li>
						<li className={activePath === '/Admin/LoanManagement' ? 'active' : ''}>
							<Link
								to="/Admin/LoanManagement"
								onClick={() => handleNavClick('/Admin/LoanManagement')}
							>
								<img src={iconLoan} className="sidebar-icon" alt="Loans" />Product Management
							</Link>
						</li>
						<li className={activePath === '/Admin/MembersRegistry' ? 'active' : ''}>
							<Link
								to="/Admin/MembersRegistry"
								onClick={() => handleNavClick('/Admin/MembersRegistry')}
							>
								<img src={iconUsername} className="sidebar-icon" alt="Members" />Member Database
							</Link>
						</li>
						<li className={activePath === '/Admin/AdminRegistry' ? 'active' : ''}>
							<Link
								to="/Admin/AdminRegistry"
								onClick={() => handleNavClick('/Admin/AdminRegistry')}
							>
								<img src={iconAdmin} className="sidebar-icon" alt="Admin" />User Management
							</Link>
						</li>
						<li className={activePath === '/Admin/ImportPage' ? 'active' : ''}>
							<Link
								to="/Admin/ImportPage"
								onClick={() => handleNavClick('/Admin/ImportPage')}
							>
								<img src={iconImport} className="sidebar-icon" alt="Import" />Data Import
							</Link>
						</li>
					</ul>
					<a href="/Admin/Login" className="logoutlink"><img src={iconLogout} className="sidebar-icon" alt="Logout" /> Logout</a>
				</div>
				<div className="copyright-font bottom-page font-green" style={{ width: "100%" }} >
					2026 © DVIA Solutions
					<span>Version 1.0.0</span>
				</div>
			</div>

			<div className="container main-container" style={{ width: isSidebarOpen ? '100%' : '100vw' }}>
				<div className="top-navbar font-size-17px" style={{ height: "50px" }}>
					<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: '20px' }}>
						<button
							className="menu-button"
							onClick={toggleSidebar}
							style={{
								background: "none",
								border: "none",
								cursor: "pointer",

							}}
						>
							<img src={iconMenu} alt="Menu" className="sidebar-icon" />
						</button>
						<div style={{ height: "100%", display: "flex", alignItems: "center" }}>
							<img src={iconUsername} className="sidebar-icon" alt="User" /> &nbsp; {logUser}
						</div>
					</div>
				</div>

				<div className="main-content">
					{children}
				</div>
			</div>
		</div >
	);
};

export default AdminLayout;


